import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { DialogSize } from '../../enums/dialog-size.enum';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-dialog-wizard-container',
	styleUrls: ['./dialog-wizard-container.component.scss'],
	templateUrl: './dialog-wizard-container.component.html',
	standalone: false,
})
export class DialogWizardContainerComponent {
	@Input() dialogSize: DialogSize = DialogSize.MEDIUM;
	@Input() disableCloseButton = false;

	@HostBinding('class') get cssClass(): string {
		switch (this.dialogSize) {
			case DialogSize.SMALL:
				return 'XCStepper-size-small';
			case DialogSize.MEDIUM:
				return 'XCStepper-size-medium';
			case DialogSize.LARGE:
				return 'XCStepper-size-large';
			case DialogSize.EXTRA_LARGE:
				return 'XCStepper-size-extra-large';
			case DialogSize.UNSET:
				return '';
			default:
				return 'XCStepper-size-medium';
		}
	}
}
